import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';

Vue.use(Vuex);
Axios.defaults.baseURL = `/content/api${process.env.BASE_URL}`;

export default new Vuex.Store({
  state: {
    laureats: null,
    currentyear: null,
    mobOpen: false,
    prixs: null,
    about: null,
    splash: null,
    cardOpen: false,
    cardActive: false,
    currentLoop: false,
    backState: false,
    ceremonies: null,
  },

  getters: {
    all: (state) => (state.laureats ? state.laureats : null),
    about: (state) => (state.about ? state.about : null),
    ceremonies: (state) => (state.ceremonies ? state.ceremonies : null),
    backState: (state) => (state.backState ? state.backState : null),
    splash: (state) => (state.splash ? state.splash : null),
    offline: (state) => (state.splash ? state.splash.offline : null),
    hidelaudatio: (state) => (state.splash ? (process.env.BASE_URL.includes('preview') ? false : state.splash.hidelaudatio) : null),

    currentyear: (state) => {
      if (state.laureats) {
        return state.laureats.map((item) => item.year.title).filter((value, index, self) => self.indexOf(value) === index)[0];
      } else {
        return null;
      }
    },

    current: (state) => {
      if (state.laureats) {
        let curr = state.laureats.map((item) => item.year.title).filter((value, index, self) => self.indexOf(value) === index)[0];
        return state.laureats.filter((item) => item.year.title === curr);
      } else {
        return null;
      }
    },

    videos: (state) => {
      if (state.laureats) {
        return state.laureats.filter((item) => item.video !== false);
      } else {
        return null;
      }
    },

    laureat: (state) => (id) => {
      if (state.laureats) {
        return state.laureats.filter((item) => item.id === id)[0];
      } else {
        return null;
      }
    },

    prix: (state) => (title) => {
      if (state.prixs) {
        return state.prixs.filter((item) => item.title === title)[0];
      } else {
        return null;
      }
    },

    isCurrent: (state) => (state.currentLoop ? 'currentLoop' : 'laureats'),

    nexti: (state) => (index, currLoop) => {
      if (state[currLoop]) {
        return state[currLoop][index];
      } else {
        return null;
      }
    },

    curri: (state) => (id, currLoop) => {
      if (state[currLoop]) {
        let ci;
        state[currLoop].reduce((acc, item, index) => {
          if (item.id === id) {
            ci = index;
          }
        }, 0);

        return ci;
      } else {
        return null;
      }
    },
  },

  mutations: {
    // Generic state modifier
    editState(state, newState) {
      state[newState.state] = newState.data;
    },
  },

  actions: {
    async loadSplash({ commit }) {
      const splash = await Axios.get('splash');
      commit('editState', { state: 'splash', data: splash.data });
    },

    async loadLaureats({ commit }) {
      const laureats = await Axios.get('laureats');
      commit('editState', { state: 'laureats', data: laureats.data.laureats });
      commit('editState', { state: 'prixs', data: laureats.data.prixs });

      let cY = this.getters.currentyear;
      commit('editState', { state: 'currentyear', data: cY });
    },

    async loadAbout({ commit }) {
      const about = await Axios.get('about');
      commit('editState', { state: 'about', data: about.data });
    },

    async loadCeremonies({ commit }) {
      const about = await Axios.get('ceremonie');
      commit('editState', { state: 'ceremonies', data: about.data });
    },
  },
});
